// extracted by mini-css-extract-plugin
module.exports = {"trustpilotContainer":"Trustpilot_trustpilotContainer__3JNDp"};